import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { Message } from 'primeng/message';
import { TagModule } from 'primeng/tag';
import { TimelineModule } from 'primeng/timeline';
import { DividerModule } from 'primeng/divider';
import { AccordionModule } from 'primeng/accordion';
import { TippyDirective } from '@ngneat/helipopper';
import { ProductService } from '../../service/product.service';
import { UserService } from '../../../user/services/user.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CarouselModule } from 'primeng/carousel';
import { GalleriaModule } from 'primeng/galleria';
import { ImageModule } from 'primeng/image';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { ProductAttributesComponent } from '../product-attributes/product-attributes.component';
import { User } from '../../../user/models/user.type';
import { ChannelService } from '../../../import/service/channel.service';
import { Shop } from '../../../shop/types/shop.type';
import { ShopService } from '../../../shop/service/shop.service';
import { SkeletonModule } from 'primeng/skeleton';
import { Util } from '../../../../utils/util';
import { CategoryService } from '../../../import/service/category.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HistoryDialogComponent } from '../../../shop/history-dialog/history-dialog.component';
import { environment } from '../../../../../environments/environment';


@Component({
  selector: 'app-seller-product',
  standalone: true,
  imports: [
    FormsModule,
    CardModule,
    TranslateModule,
    ButtonModule,
    SelectModule,
    Message,
    TagModule,
    TimelineModule,
    DividerModule,
    AccordionModule,
    TippyDirective,
    ScrollPanelModule,
    CarouselModule,
    GalleriaModule,
    ImageModule,
    InputTextModule,
    FileUploadModule,
    ProductAttributesComponent,
    SkeletonModule,
    RouterLink
  ],
  templateUrl: './seller-product.component.html',
  styleUrl: './seller-product.component.scss',
  providers: [DialogService],
})
export class SellerProductComponent implements OnInit {
  messages = [];
  user: User;
  productId;
  product;
  masterProductStatus: string = 'Publiable';
  shops: Shop[];
  selectedShop: Shop;
  Util = Util;

  steps = [
    {
      tag: '1/3',
      severity: 'info',
      header: 'detailsProduct.format',
      summary: 'Valide',
      color: '#256029',
      date: '-',
      tooltip: 'detailProduct.formatDescription',
    },
    {
      tag: '2/3',
      severity: 'info',
      header: 'detailsProduct.editorialCharter',
      summary: 'Modification requise',
      date: '-',
      color: '#C63737',
      tooltip: 'detailProduct.editorialCharterDescription',
    },
    {
      tag: '3/3',
      severity: 'info',
      header: 'detailsProduct.systemInfo',
      summary: '-',
      color: '#757575',
      date: '',
      tooltip: 'detailProduct.systemInfoDescription',
    },
  ];
  productStatuses = {};
  selectedChannel;
  categories;
  ref: DynamicDialogRef | undefined;
  expandedStates: boolean[] = [];
  @ViewChild('productAttributes') productAttributes: ProductAttributesComponent;
  constructor(
    private readonly productService: ProductService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly userService: UserService,
    private readonly channelService: ChannelService,
    private readonly shopService: ShopService,
    private readonly categoryService: CategoryService,
    private readonly dialogService: DialogService,
    public translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.user = this.userService.getUser();
    this.initCategories();
    this.activatedRoute.params.subscribe((params) => {
      this.initInfo(params['id']);
    });
  }

  initCategories() {
    Util.initCategories(this.categoryService, this.channelService)().then(
      (categories) => {
        this.categories = categories;
        for (let node of this.categories) {
          Util.handleSlectableNodes(node);
        }
      },
    );
  }

  initInfo(id) {
    this.productId = id;
    this.selectedShop = this.shopService.getSelectedShop();
    this.selectedChannel = this.channelService.getSelectedChannel();
    this.initProduct(this.selectedChannel);
  }

  refreshProduct(event) {
    this.initProduct(this.selectedChannel);
  }

  initProduct(channel) {
    this.messages = [];
    this.productService
      .getProduct(
        this.productId,
        this.user?.email,
        channel.channelCode,
        this.channelService.getSavedLocales(),
        this.channelService.getSelectedLocale(),
      )
      .subscribe({
        next: (data) => {
          this.product = data;
          let i = 0;
          for (let status of this.product.mergedProduct.productStatus) {
            this.steps[i].summary = status.statusText;
            this.steps[i].date = status.statusDate;
            this.steps[i].header = 'detailProduct.' + status.statusCode;
            i++;
          }
          if (this.product.editorialCharter?.rejection || '') {
            this.messages.push({
              severity: this.product.editorialCharter.status,
              summary: this.product.editorialCharter.rejection,
              detail: this.product.editorialCharter.description,
            });
          }
          if (this.product.publicationStatusErrors?.length > 0) {
            const messages = this.product.publicationStatusErrors
              .map((error) => Util.buildMessage('-', error, ['level', 'attributeCode', 'message']) )
              
            this.messages.push({
              severity: this.product.publicationStatusErrors[0].status.toString().trim() === "SYNCHRONIZED" ? 'Warning' :'Error',
              summary: this.product.publicationStatusErrors[0].status,
              detail: messages,
            });
          }
          if (this.productAttributes) {
            this.productAttributes.fetchAndInitializeProductAttributes(
              this.product,
            );
          }
        },
      });
  }

  openHistoryDialog() {
    this.ref = this.dialogService.open(HistoryDialogComponent, {
      header: this.translate.instant('shop.actionsHistory'),
      closable: true,
      data: { productId: this.productId, type: 'product' },
      width: '65vw',
      height: '75vh',
      modal: true,
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw',
      },
    });
  }



  isPublicationStatusErrors(product) {
    return product?.publicationStatusErrors.length > 0 ? product?.publicationStatusErrors[0].message != "" : false;
  }
  
  getSeverityForPublicationStatus(status, product) {
    return Util.getSeverityForPublicationStatus(status, this.isPublicationStatusErrors(product));
  }

   // Nouvelle méthode pour toggle l'expansion d'un message dans la liste
  toggleExpand(index: number): void {
    // Initialise le tableau si nécessaire
    if (!this.expandedStates[index]) {
      this.expandedStates[index] = false;
    }
    
    // Toggle l'état
    this.expandedStates[index] = !this.expandedStates[index];
  }

  onDownload() {
    let url = environment.docsBucketUrl;
    if(this.translate.currentLang === 'fr') {
      url = url + "Product/FR/Guide%20des%20messages%20d%E2%80%99erreur%20du%20Portail%20Catalogue.pdf";
    } else {
      url = url + "Product/EN/Catalog%20Portal%20Error%20Message%20Guide.pdf"
    }
    Util.downloadDoc(url)
  }

  getTutoLink() {
    if(this.translate.currentLang === 'fr') {
      return environment.docsBucketUrl +'Fiche%20produit/FR/Catalog%20-%20FR%20-%20Vendeur%20-%20Consulter%20une%20fiche%20produit%2C%20comprendre%20les%20statuts%20de%20la%20fiche%2C%20des%20attributs%20et%20les%20modifications%20%C3%A0%20apporter.pdf'
    }else {
      return environment.docsBucketUrl + "Fiche%20produit/EN/Catalog%20-%20EN%20-%20Seller%20-%20Consult%20a%20product%20sheet%2C%20understand%20the%20sheet'%20status%2C%20attributes%20and%20the%20modifications%20to%20make.pdf"
    }
    
  }
}
